import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import { Fees } from './Fees';

export const FeesWrapper = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <Fees />
      </div>
      <Footer />
    </>
  );
};
